import { useState } from 'react';
import { ResidentsListPanel } from '@/views';
import { Modal } from 'antd';

export function useEditHomeResidentsAction() {
  const [homeId, setHomeId] = useState<string | null>();
  const [communityId, setCommunityId] = useState<string | null>();
  const [projectId, setProjectId] = useState<string | null>();

  const setValues = (
    homeId: string | null,
    communityId: string | null,
    projectId: string | null,
  ) => {
    setHomeId(homeId);
    setCommunityId(communityId);
    setProjectId(projectId);
  };

  const onCancel = () => setValues(null, null, null);

  return {
    openEdit: (homeId: string, communityId: string, projectId: string) =>
      setValues(homeId, communityId, projectId),
    editModal: (
      <>
        {homeId && communityId && projectId && (
          <Modal visible width={1000} onCancel={onCancel} onOk={onCancel}>
            <div style={{ paddingRight: '20px', paddingTop: '10px' }}>
              <ResidentsListPanel
                homeId={homeId}
                communityId={communityId}
                projectId={projectId}
              />
            </div>
          </Modal>
        )}
      </>
    ),
  };
}
